import type { ClipboardPayload } from "hooks/useCopyToClipboard";

function escapeHtml(unsafe: string): string {
  return unsafe
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

/**
 * Build a clipboard payload that pastes as a named hyperlink.
 *
 * The plain-text half uses Slack's `<url|label>` link syntax so a paste into
 * Slack renders a named link rather than a bare URL; rich targets (Linear,
 * Google Docs) pick up the `text/html` anchor instead. `>` and `|` are stripped
 * from the label because they terminate Slack's link syntax.
 */
export function buildRichLinkPayload(url: string, label: string): ClipboardPayload {
  return {
    plainText: `<${url}|${label.replace(/[>|]/g, " ")}>`,
    html: `<a href="${escapeHtml(url)}">${escapeHtml(label)}</a>`,
  };
}
